/**
 * 请去 router/account.js里面设置路由
 */
const routers = [
	{
		path: '/account',
		title: '我的账户',
		children: []
	},
	{
		path: '/account/setting',
		title: '账户设置',
		children: [
			{
				path: '/account/userinfo',
				title: '个人资料',
				children: []
			},
			{
				path: '/account/passManage',
				title: '登录密码管理',
				children: []
			},
			{
				path: '/account/authHome',
				title: '认证中心',
				children: []
			},
			{
				path: '/commissionShare',
				name: 'inviter',
				title: '我的邀请'
			},
			{
				path: '/commissionShare/inviter',
				name: 'inviter',
				title: '邀请中心'
			}
		]
	},
	{
		path: '/account/coupon',
		title: '我的券包',
		children: []
	},
	{
		path: '/promotionRebate',
		title: '推广返利',
		childrenDot: true,
		children: []
	},
	{
		path: '/account/buyer-center',
		title: '买家中心',
		childrenDot: true,
		children: [
			{
				path: '/gameList?from=account',
				title: '我要买',
				children: []
			},
			{
				path: '/account/buyerList',
				title: '购买订单',
				dotKey: 'myOrder',
				children: []
			},
			{
				path: '/account/afterSales',
				title: '我的售后',
				children: []
			},
			{
				path: '/account/collection',
				title: '收藏商品',
				children: []
			}
		]
	},
	{
		path: '/account/seller-center',
		title: '卖家中心',
		childrenDot: true,
		children: [
			{
				path: '',
				title: '我要卖',
				enName: 'sell',
				children: []
			},
			{
				path: '/account/sellOrder',
				title: '出售订单',
				children: []
			},
			{
				path: '/account/sellerList',
				title: '商品管理',
				dotKey: 'myGoods',
				children: []
			},
		]
	},
	{
		path: '/account/serveList',
		title: '服务订单',
		children: []
	},
	{
		path: '/account/bargainMe',
		childrenDot: true,
		title: '砍价中心',
		children: [
			{
				path: '/account/bargainMe',
				title: '我是买家',
				dotKey: 'bargainBuyer',
				children: []
			},
			{
				path: '/account/bargainSeller',
				title: '我是卖家',
				dotKey: 'bargainSeller',
				children: []
			}
		]
	},
	{
		path: '/account/recovery',
		title: '回收中心',
		children: []
	},
	{
		path: '/account/business',
		title: '商家中心',
		children: []
	},
	{
		path: '/account/addMoney',
		title: '资产中心',
		children: [
			// {
			//     path: '/account/addMoney',
			//     title: '充值',
			//     children: []
			// },
			{
				path: '/account/tiXian',
				title: '申请提现',
				children: []
			},
			// {
			//     path: '/account/tiXianHistory',
			//     title: '提现记录',
			//     children: []
			// },
			{
				path: '/account/mingXi',
				title: '账单明细',
				children: []
			},
			{
				path: '/account/tiXianAccount',
				title: '提现账户',
				children: []
			},
			{
				path: '/account/setPayPassword',
				title: '支付密码',
				children: []
			}
		]
	},
	{
		path: '/account/serviceCenter',
		title: '服务中心',
		children: [
			{
				path: '/account/message',
				title: '系统消息',
				children: []
			},
			{
				path: '/helpCenter',
				title: '帮助中心',
				children: []
			},
			{
				path: '/advise',
				title: '投诉与建议',
				children: []
			},
			{
				path: '/services',
				title: '联系客服',
				children: []
			}
		]
	},
	{
		path: '/account/equityExchange',
		title: '权益兑换',
		children: [
			{
				path: '/account/equityExchange',
				title: '权益兑换',
				children: []
			}
		]
	}
]

// setTimeout(() => {
//     if (process.client) {
//         let userinfo = window.$nuxt.$store.state.user.userinfo
//         // 判断是否登录和是否为商家
//         if (userinfo && userinfo.recovery) {
//             const business = {
//                 path: '/account/business',
//                 title: '商家中心',
//                 children: []
//             }
//             routers.splice(6, 0, business)
//         }
//     }
// }, 300)
export default routers
